export function attachDrag(element: HTMLElement): () => void {
  const state = {
    drag: false,
    move: false,
    x: 0,
    left: 0,
  }

  function onStartDrag() {
  }

  function onEndDrag() {
  }

  function startDrag(clientX: number) {
    state.drag = true
    state.move = false
    onStartDrag()
    state.x = clientX
    state.left = element.scrollLeft
  }

  function moveDrag(clientX: number) {
    state.move = true
    requestAnimationFrame(() => {
      const left = state.left + (state.x - clientX)
      element.scrollLeft = left
    })
  }

  function endDrag() {
    state.drag = false
    onEndDrag()
  }

  function onClick(event: MouseEvent) {
    if (state.move) {
      event.stopPropagation()
    }
  }

  function onPointerDown(event: PointerEvent) {
    if (event.button > 0) return
    // на тач и пере скроллит сам браузер — с инерцией и без конфликта с нативным жестом
    if (event.pointerType !== 'mouse') return
    event.preventDefault()
    startDrag(event.clientX)
  }

  function onPointerMove(event: PointerEvent) {
    if (!state.drag) return
    element.setPointerCapture(event.pointerId)
    moveDrag(event.clientX)
  }

  function onPointerUp(event: PointerEvent) {
    if (!state.drag) return
    try {
      element.releasePointerCapture(event.pointerId)
    } catch {
      // уже снят или отменён
    }
    endDrag()
    setTimeout(() => {
      state.move = false
    }, 10)
  }

  element.addEventListener('click', onClick)
  element.addEventListener('pointerdown', onPointerDown)
  element.addEventListener('pointermove', onPointerMove)
  element.addEventListener('pointerup', onPointerUp)
  element.addEventListener('pointercancel', onPointerUp)

  return () => {
    element.removeEventListener('click', onClick)
    element.removeEventListener('pointerdown', onPointerDown)
    element.removeEventListener('pointermove', onPointerMove)
    element.removeEventListener('pointerup', onPointerUp)
    element.removeEventListener('pointercancel', onPointerUp)
  }
}
